export default __webpack_public_path__ + "static/media/shared.fd32e347.svg";